var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47323 6.28637H0.30932C0.138498 6.28637 0 6.14778 0 5.97684V0.809524C0 0.638589 0.138498 0.5 0.30932 0.5H1.5466C1.71742 0.5 1.85592 0.638589 1.85592 0.809524V2.82432C3.03579 1.51315 4.7496 0.692679 6.65488 0.70653C10.1839 0.732169 13.0075 3.58569 13 7.11708C12.9925 10.6436 10.1333 13.5 6.6074 13.5C4.95541 13.5 3.44987 12.8729 2.31534 11.8437C2.1839 11.7244 2.17784 11.5198 2.3033 11.3943L3.17885 10.5182C3.29418 10.4028 3.47946 10.3965 3.60162 10.5047C4.40162 11.213 5.45382 11.6429 6.6074 11.6429C9.11465 11.6429 11.1441 9.61248 11.1441 7.10317C11.1441 4.5943 9.11506 2.56349 6.6074 2.56349C5.09957 2.56349 3.76476 3.29799 2.94006 4.42922H5.47323C5.64405 4.42922 5.78255 4.56781 5.78255 4.73875V5.97684C5.78255 6.14778 5.64405 6.28637 5.47323 6.28637Z",
    fill: "#05396B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.5157282b43b61f107b2cba67b709fb35.svg";
export { ForwardRef as ReactComponent };